// Findings of a read-only operation: rows of arbitrary JSON objects.

export type Finding = Record<string, unknown>

/** A cell's text: scalars as-is, objects/arrays as compact JSON. */
export function cellText(v: unknown): string {
  if (v === null || v === undefined) return ''
  if (typeof v === 'object') {
    try {
      return JSON.stringify(v)
    } catch {
      return String(v)
    }
  }
  return String(v)
}

/** Union of keys across rows, in first-seen order. */
export function findingColumns(findings: Finding[]): string[] {
  const seen = new Set<string>()
  for (const row of findings) for (const k of Object.keys(row)) seen.add(k)
  return [...seen]
}
